export class MaestroMarcas {
    id: number;
    codigo: string;
    descripcion: string;
    idAliado: number;
}